<script setup>
import { useId } from 'vue';

// SiteUp/F1.4: ícones animados do conjunto line-md (Iconify) para os 3 pontos
// travados no roadmap V2 — toggle do menu mobile (hambúrguer↔X) e o double
// check de mensagem lida. Renderizados como <svg> inline (não como classe
// utilitária `i-line-md-*` do @egoist/tailwindcss-icons) de propósito: a
// animação desses ícones é SMIL (<animate>) dentro do próprio SVG, e
// verificação visual mostrou que ela NÃO toca quando o plugin achata o SVG
// em `mask-image` (a máscara fica congelada num único frame, nunca
// interpola) — só funciona com o SVG vivo no DOM. Ver PR da F1.4 para a
// evidência (screenshots comparando mask-image vs. inline em slow motion).
//
// Corpo do SVG copiado ipsis literis de node_modules/@iconify-json/line-md
// (icons.json) para os nomes: menu-to-close-transition,
// close-to-menu-transition, check-all.
defineProps({
  name: {
    type: String,
    required: true,
    validator: value =>
      ['menu-to-close', 'close-to-menu', 'check-all'].includes(value),
  },
});

// mask id precisa ser único por instância: MessageStatus renderiza esse
// ícone uma vez por mensagem lida/entregue numa conversa, e um id de mask
// duplicado no DOM faria `url(#id)` resolver sempre pro primeiro elemento.
const maskId = `line-md-check-all-mask-${useId()}`;
</script>

<template>
  <svg
    v-if="name === 'menu-to-close'"
    key="menu-to-close"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 5l7 7l7 -7M12 12h0M5 19l7 -7l7 7"
    >
      <animate
        fill="freeze"
        attributeName="d"
        dur="0.4s"
        values="M5 5l7 0l7 0M5 12h14M5 19l7 0l7 0;M5 5l7 7l7 -7M12 12h0M5 19l7 -7l7 7"
      />
    </path>
  </svg>
  <svg
    v-else-if="name === 'close-to-menu'"
    key="close-to-menu"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 5l7 0l7 0M5 12h14M5 19l7 0l7 0"
    >
      <animate
        fill="freeze"
        attributeName="d"
        dur="0.4s"
        values="M5 5l7 7l7 -7M12 12h0M5 19l7 -7l7 7;M5 5l7 0l7 0M5 12h14M5 19l7 0l7 0"
      />
    </path>
  </svg>
  <svg
    v-else-if="name === 'check-all'"
    key="check-all"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <defs>
      <mask :id="maskId">
        <g
          fill="none"
          stroke-dasharray="24"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path stroke="#fff" stroke-width="2" d="M2 13.5l4 4l10.75 -10.75">
            <animate
              fill="freeze"
              attributeName="stroke-dashoffset"
              dur="0.5s"
              values="24;0"
            />
          </path>
          <path
            stroke="#000"
            stroke-dashoffset="24"
            stroke-width="6"
            d="M7.5 13.5l4 4l10.75 -10.75"
          >
            <animate
              fill="freeze"
              attributeName="stroke-dashoffset"
              begin="0.5s"
              dur="0.3s"
              to="0"
            />
          </path>
        </g>
      </mask>
    </defs>
    <path fill="currentColor" d="M0 0h24v24H0z" :mask="`url(#${maskId})`" />
    <path
      fill="none"
      stroke="currentColor"
      stroke-dasharray="24"
      stroke-dashoffset="24"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M7.5 13.5l4 4l10.75 -10.75"
    >
      <animate
        fill="freeze"
        attributeName="stroke-dashoffset"
        begin="0.5s"
        dur="0.3s"
        to="0"
      />
    </path>
  </svg>
</template>
